import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { NavHeader } from "../components/NavHeader";
import { Footer } from "../components/Footer";

export const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Page not found · Astrarium";
  }, []);
  return (
  <>
    <NavHeader />

    <main className="relative z-10 min-h-[80vh] flex flex-col items-center justify-center text-center px-6 py-20" data-testid="not-found-page">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <p className="text-stardust/70 uppercase tracking-[0.5em] text-[10px] mb-5">Lost among the stars</p>
        <h1 className="font-display text-5xl sm:text-6xl text-[#F5EBD8] mb-5">
          404<span className="text-stardust">.</span>
        </h1>
        <p className="font-serif-italic text-slate-300 text-lg mb-8 max-w-md">
          This corner of the sky is empty. The page you were seeking has drifted on.
        </p>
        <Link
          to="/"
          className="inline-flex items-center bg-stardust hover:bg-stardust-light text-cosmic-900 px-10 py-4 rounded-md uppercase tracking-[0.3em] text-xs font-medium"
        >
          Return home
        </Link>
      </motion.div>
    </main>

    <Footer />
  </>
  );
};
